import { AnswerElementType } from 'shared/types/AnswerElement';

import { DefaultAnswerConfig } from '@/widgets/utils/generateDefaultAnswer';

export const DEFAULT_ANSWERS_AMOUNT = 4;
export const INTERACTIVE_QUIZ_MAX_COLUMN_AMOUNT = 4;

export const allowedElementTypesCombinations: AnswerElementType[][] = [['Text'], ['Image'], ['Text', 'Image']];

export const defaultAnswerConfig: DefaultAnswerConfig = { hasText: true, hasImage: true };
